<template>
    <div>
        <div class="col-sm-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px"
                        >{{ $t('landingPage.settingContact.titleBlock') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="contactForm.title_block"
                            :config.sync="configForm.configFieldTitleBlockContact"
                            @blur="handleValidateField(configForm.configFieldTitleBlockContact)"
                        />
                        <div class="mt-3">
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.setSizeText') }}</label>
                                <div class="col-sm-3">
                                    <div class="d-flex align-items-center" style="gap: 0.5rem">
                                        <InputText
                                            style="max-width: 120px"
                                            :model.sync="contactForm.size_title"
                                            :config.sync="configForm.configFieldSizeTitle"
                                        />
                                        <span>px</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.colorText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="contactForm.color_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="contactForm.color_title"
                                            :config="{
                                                error: false
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="contactForm.background_title"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="contactForm.background_title"
                                            :config="{
                                                error: false
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.background') }}</label>
                    <div class="col-sm-10">
                        <UploadImageCommon
                            :fileValues.sync="contactForm.background_image"
                            :id="`BackgroundImgContact`"
                            :config="{
                                maxSize: 2048
                            }"
                        >
                            <template #warning>
                                <div style="font-size: 13px">
                                    {{ $t('noteUploadMaxMB') }}
                                </div>
                            </template>
                        </UploadImageCommon>
                        <div class="form-group row mt-2">
                            <label class="col-sm-1 text-nowrap" style="min-width: 120px">{{ $t('landingPage.backgroundText') }}</label>
                            <div class="col-sm-5">
                                <div class="d-flex" style="gap: 1rem">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="contactForm.background_color"
                                        :config="{
                                            type: 'color',
                                            classCustom: 'form-control-color',
                                            error: false
                                        }"
                                    />
                                    <InputText
                                        style="max-width: 100px"
                                        :model.sync="contactForm.background_color"
                                        :config="{
                                            error: false
                                        }"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <InputCheckBox
                                :model.sync="contactForm.is_repeat"
                                :id="`check-repeat-background-contact`"
                                :value="contactForm.is_repeat"
                                :label="`repeat`"
                            />
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.style') }} </label>
                    <div class="col-sm-10">
                        <div class="d-flex flex-wrap" style="gap: 1rem">
                            <div v-for="item in listStyleContact" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4"
                                    :model.sync="contactForm.style"
                                    :name="`contact_setting-style`"
                                    :id="`contact_setting-style-${item.id}`"
                                    :value="item"
                                    :label="item.name"
                                    @change="handleShotCodeStyle('select')"
                                />
                                <div class="mt-2" style="width: 100px; height: 80px">
                                    <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.contactOfficeName') }}</label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="contactForm.contact_secretariat_name"
                            :config.sync="configForm.configFieldContactOfficeName"
                            @blur="handleValidateField(configForm.configFieldContactOfficeName)"
                            @change="handleShotCodeStyle"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.tel') }} </label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="contactForm.tel"
                            :config.sync="configForm.configFieldTel"
                            @blur="handleValidateField(configForm.configFieldTel)"
                            @change="handleShotCodeStyle"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.mail') }}</label>
                    <div class="col-sm-10">
                        <InputText
                            :model.sync="contactForm.mail"
                            :config.sync="configForm.configFieldMail"
                            @blur="handleValidateField(configForm.configFieldMail)"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 170px">{{ $t('landingPage.settingContact.detail') }} </label>
                    <div class="col-sm-10">
                        <Editor
                            v-if="isVisibleEditor"
                            :id="`editorStyleContact`"
                            :isBackgroundImageEditor="false"
                            :model.sync="contactForm.html_content"
                            :modelEvents="`change keydown blur focus paste`"
                            :configInit="configEditor"
                            @init="onEditorInit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputText, InputCheckBox, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { LIST_STYLE_CONTACT } from '../../styles';
import { tranferShortCode, transferHTMLToShortcode } from '@/utils/format';
import { onHandleChangeTemp, mapImageDefault } from '../../handlers';
import { cloneDeep } from 'lodash';

import Editor from '@/components/Editor/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';

export default {
    name: 'SettingContact',
    components: {
        InputText,
        InputCheckBox,
        Editor,
        UploadImageCommon,
        InputRadio
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    computed: {
        ...mapState({
            ...mapState('landingPage', ['infoSettingLandingPage', 'idxRefreshCampaign'])
        })
    },

    data() {
        return {
            isVisibleEditor: false,
            objEditor: null,
            contactForm: cloneDeep(this.dataForm),
            configEditor: {
                height: 600,
                content_style: ''
            },
            listStyleContact: mapImageDefault(LIST_STYLE_CONTACT)
        };
    },
    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },

        onEditorInit(editor) {
            this.objEditor = editor;
        },

        onHandleTimeOutCssEditor(timer = 500) {
            setTimeout(() => {
                let { style } = this.contactForm;
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
            }, timer);
        },

        handleShotCodeStyle(type = null) {
            let { style, contact_secretariat_name, tel } = this.contactForm;
            if (!style) return;
            let addProper = '';
            let contentShotCode = '';
            if (type === 'select') {
                this.contactForm.html_content = '';
                this.configEditor.content_style = '';
                this.objEditor.setContent('');
                this.contactForm.background_color = style?.backgroundColorDefault ?? '#ffffff';
                this.updateEditorStyle(this.objEditor, style?.cssStyle);
                this.configEditor.content_style = style?.cssStyle;
            }
            let { contents } = this.contactForm.style;
            const replacements = {
                お問い合わせ事務局名: contact_secretariat_name ?? '',
                TEL: tel ?? ''
            };
            if (!this.contactForm?.html_content) {
                contentShotCode = tranferShortCode(contents, replacements);
                addProper = contentShotCode;
            } else {
                const placeholders = {
                    shotCompany: '《お問い合わせ事務局名》',
                    shotPhone: '《TEL》'
                };
                const resultContent = transferHTMLToShortcode(placeholders, this.contactForm.html_content);
                contentShotCode = tranferShortCode(resultContent, replacements);
                const div = document.createElement('div');
                div.innerHTML = contentShotCode;
                const sourceContactElement = div.querySelector(`.inquiry-box`);
                addProper = sourceContactElement.outerHTML;
            }
            this.objEditor.setContent(addProper ?? '');
            this.contactForm.html_content = addProper;
        },

        updateEditorStyle(editor, newCss) {
            const head = editor?.contentDocument?.head || editor?.getDoc()?.head;
            if (!head) return;
            let styleTag = head.querySelector('#dynamic-editor-style');
            if (!styleTag) {
                styleTag = document.createElement('style');
                styleTag.id = 'dynamic-editor-style';
                head.appendChild(styleTag);
            }
            styleTag.innerHTML = newCss;
        }
    },

    watch: {
        infoSettingLandingPage: {
            handler: function (newSetting) {
                let { style } = this.contactForm;
                if (style) return;
                let checkTem = onHandleChangeTemp(newSetting, this.contactForm, this.listStyleContact);
                if (checkTem && this.objEditor) this.handleShotCodeStyle('select');
            },
            immediate: true,
            deep: true
        },

        dataForm: {
            handler: function (newDataForm) {
                this.contactForm = newDataForm;
            },
            deep: true
        },

        contactForm: {
            handler: function (newContactForm) {
                this.$emit('update:dataForm', newContactForm);
            },
            immediate: true,
            deep: true
        },

        idxRefreshCampaign: {
            handler: function () {
                this.handleShotCodeStyle();
            },
            deep: true
        }
    },

    mounted() {
        setTimeout(() => {
            this.isVisibleEditor = true;
        }, 300);
        this.onHandleTimeOutCssEditor(2000);
    }
};
</script>

<style lang="scss" scoped></style>
